module.exports = __webpack_public_path__ + "img/reviews-author-14@2x.23ce18a.jpg";